import { request } from '../request';

// 用于在途请求去重 (In-flight request deduplication)，防止 React 严格模式或双重挂载引发重复网络请求
const inFlightRequests = new Map<string, Promise<any>>();

function getDeduplicatedRequest<T>(cacheKey: string, requestFn: () => Promise<T>): Promise<T> {
  if (inFlightRequests.has(cacheKey)) {
    return inFlightRequests.get(cacheKey)!;
  }

  const promise = requestFn().finally(() => {
    setTimeout(() => {
      inFlightRequests.delete(cacheKey);
    }, 300);
  });

  inFlightRequests.set(cacheKey, promise);
  return promise;
}

/**
 * 查询收到的供给方合作线索
 * GET /my/provider-cooperation-leads/inbox
 *
 * @param params 分页参数 (page, page_size)
 */
export function fetchGetReceivedLeads(params?: Api.Lead.QueryLeadsParams) {
  const cacheKey = `received:${params?.page || 1}:${params?.page_size || 20}`;
  return getDeduplicatedRequest(cacheKey, () =>
    request<Api.Lead.LeadPageResponse>({
      url: '/my/provider-cooperation-leads/inbox',
      method: 'GET',
      params,
    })
  );
}

/**
 * 查询已发送的供给方合作线索
 * GET /my/provider-cooperation-leads/sent
 *
 * @param params 分页参数 (page, page_size)
 */
export function fetchGetSentLeads(params?: Api.Lead.QueryLeadsParams) {
  const cacheKey = `sent:${params?.page || 1}:${params?.page_size || 20}`;
  return getDeduplicatedRequest(cacheKey, () =>
    request<Api.Lead.LeadPageResponse>({
      url: '/my/provider-cooperation-leads/sent',
      method: 'GET',
      params,
    })
  );
}

/**
 * 接受收到的线索
 * POST /provider-cooperation-leads/{id}/accept
 *
 * @param id 线索 ID
 */
export function fetchAcceptLead(id: string | number) {
  return request<Api.Lead.LeadResponse>({
    url: `/provider-cooperation-leads/${id}/accept`,
    method: 'POST',
  });
}

/**
 * 关闭线索
 * POST /provider-cooperation-leads/{id}/close
 *
 * @param id 线索 ID
 */
export function fetchCloseLead(id: string | number) {
  return request<Api.Lead.LeadResponse>({
    url: `/provider-cooperation-leads/${id}/close`,
    method: 'POST',
  });
}

/**
 * 拒绝收到的线索
 * POST /provider-cooperation-leads/{id}/decline
 *
 * @param id 线索 ID
 */
export function fetchDeclineLead(id: string | number) {
  return request<Api.Lead.LeadResponse>({
    url: `/provider-cooperation-leads/${id}/decline`,
    method: 'POST',
  });
}

/**
 * 发送合作或招聘线索
 * POST /providers/{id}/cooperation-leads
 *
 * @param id 供给方档案 ID
 * @param data 请求体模型 (LeadRequest)
 */
export function fetchSendCooperationLead(id: string | number, data: Api.Lead.LeadRequest) {
  return request<Api.Lead.LeadResponse>({
    url: `/providers/${id}/cooperation-leads`,
    method: 'POST',
    data,
  });
}
